export default __webpack_public_path__ + "static/ProximaNova-ThinIt-7dd55548d8533687fa41bd3484da20e6.woff2";